import React, { useContext, useEffect, useRef, useState } from 'react';
import { GlobleContaxt } from '../../Context/GlobleContaxt';
import { isEmpty } from 'lodash';
import { CustomDropdownWrapper } from '../CustomDropdown/style';

import Input from '../UIbox/Input';
import { clickOutside } from '../../utils/common';


const CustomDropdown = ({ list, setProvider,setProviderName=()=>{}, type, provider = '', error="", accessLoaction = true }) => {
	const [searchQuery, setSearchQuery] = useState('');

	const [listShow, setListShow] = useState(false);
	const [isActive, setIsActive] = useState('');
	const { setAlert } = useContext(GlobleContaxt);
	const handleSearchChange = (e) => {
		setSearchQuery(e.target.value);
	};

	const handleOptionSelect = (value, name) => {
		setIsActive(name);
		setSearchQuery(name);
		setProvider(value?.billerId);
		setProviderName(name);
		setListShow(false);
	};
	useEffect(() => {
		if (provider === '') {
			setSearchQuery('');
			setProviderName("");
		}
	}, [provider]);

	const blur = () => {
		
	};

	const handalFocus = () => {
		if (isEmpty(localStorage.getItem('ID Token'))) {
		    setAlert({ type: 'error', msg: 'Please login first to continue' });

			return;
		}

		setListShow(true);
	};
const boxRef = useRef(null)
	useEffect(() =>{
		clickOutside(true,boxRef,()=>setListShow(false),"all")
		return (() =>clickOutside(false,boxRef,()=>setListShow(false),"all"))
	},[]);


	return (
		<CustomDropdownWrapper ref={boxRef}>
			<Input
				label={"Search Biller"}
				name={"Search_Biller"}
				onChange={(e) => handleSearchChange(e)}
				value={searchQuery}
				required={true}
				onFocus={handalFocus} 
				onBlur={blur}
				type='search'
			 error={error}
			/>

			{listShow && list?.length > 0 && (
				<div className="dropdown">
					{type === 'bill' && (
						<>
							{list
								.filter((option) => option.billerName.toLowerCase().startsWith(searchQuery.toLowerCase()))
								.map((option, index) => (
									<div
										key={index}
										className={isActive === option.billerName ? 'dropdown-option active' : 'dropdown-option'}
										onClick={() => handleOptionSelect(option, option?.billerName)}
									>
										<div className="icons">{/* <img src={option.iconUrl} alt='operator-img' /> */}</div>
										<div className="name">{option.billerName}</div>
									</div>
								))}
						</>
					)}
					{type === 'mobile' && (
						<>
							{list?.filter((option) => option.operatorName.toLowerCase().startsWith(searchQuery.toLowerCase()))
								.map((option, index) => (
									<div
										key={index}
										className={isActive === option.operatorName ? 'dropdown-option active' : 'dropdown-option'}
										onClick={() => handleOptionSelect(`${option?.operatorId},${option?.operatorCode}`, option?.operatorName)}
									>
										<div className="icons">
											<img src={option.operatorImage} alt="oprtator-imf" />
										</div>
										<div className="name">{option.operatorName}</div>
									</div>
								))}
						</>
					)}
				</div>
			)}
		</CustomDropdownWrapper>
	);
};

export default CustomDropdown;
